module.exports = __webpack_public_path__ + "static/12-IMG_6882-c1e4b5a8fffd79943e8bf33ffb469d4b.jpg";